/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_CardInputs */

const en_current_card = /** @type {(inputs: Current_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Card`)
};

const fr_current_card = /** @type {(inputs: Current_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte actuelle`)
};

const de_current_card = /** @type {(inputs: Current_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Karte`)
};

const it_current_card = /** @type {(inputs: Current_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carta attuale`)
};

const ru_current_card = /** @type {(inputs: Current_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущая карта`)
};

const es_current_card = /** @type {(inputs: Current_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjeta corriente`)
};

const zh_cn2_current_card = /** @type {(inputs: Current_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前卡`)
};

const ja_current_card = /** @type {(inputs: Current_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のカード`)
};

const hi_current_card = /** @type {(inputs: Current_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान कार्ड`)
};

const pt_pt2_current_card = /** @type {(inputs: Current_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartão atual`)
};

/**
* | output |
* | --- |
* | "Current Card" |
*
* @param {Current_CardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const current_card = /** @type {((inputs?: Current_CardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_CardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_current_card(inputs)
	if (locale === "de") return de_current_card(inputs)
	if (locale === "it") return it_current_card(inputs)
	if (locale === "ru") return ru_current_card(inputs)
	if (locale === "es") return es_current_card(inputs)
	if (locale === "zh-CN") return zh_cn2_current_card(inputs)
	if (locale === "ja") return ja_current_card(inputs)
	if (locale === "hi") return hi_current_card(inputs)
	if (locale === "pt-PT") return pt_pt2_current_card(inputs)
	return en_current_card(inputs)
});